export default {
    data() {
        return {
            quantities: [],
            submitted: false,
            success: false,
            show_cart_link: false,
        }
    },
    props: {
        product: Object,
        showTitle: {
            type: Boolean,
            default: false,
        },
        category: {
            type: Boolean,
            default: false,
        },
        viewOnly: {
            type: Boolean,
            default: false,
        },
        afterpayLogo: {
            type: String,
            default: null,
        },
    },
    beforeMount() {
        this.setDefaultQuantities();
    },
    computed: {
        hasSelected() {
            return this.quantities.some((quantity) => quantity > 0)
        },
        totalSelected() {
            return this.quantities.reduce((total, quantity) => total + quantity, 0)
        },
        hasStock() {
            return this.product.gift_card || this.product.options.some(({quantity}) => quantity > 0)
        },
        totalPrice() {
            return this.quantities
                .map((quantity, index) => Number(this.product.options[index].price) * quantity)
                .reduce((total, price) => total + price, 0)
        },
        paypalMessage() {
            if (this.totalPrice > 3000 && this.totalPrice < 150000) {
                return `Pay in 4 interest-free payments of ${this.money(this.totalPrice / 4)}`
            }
            return `Pay in 4 interest-free payments on purchases of $30-$1,500`;
        },
        afterpayMessage() {
            if (this.totalPrice > 0 && this.totalPrice < 200000) {
                return `4 payments from just ${this.money(this.totalPrice / 4)} with`
            }
            return `Fortnightly Instalments Available with `;
        },
        hasUnitPrice() {
            return this.product.options.some((option) => {
                return option.unit_price && option.unit_price.length;
            })
        },
    },
    watch: {
        success(value) {
            if (value === true) {
                setTimeout(() => this.success = false, 3000);
            }
        },
        totalSelected(value) {
            this.$emit('selected', {product: this.product.id, value: this.hasSelected, items: this.buildProductCall()});
        }
    },
    methods: {
        money(value) {
            return `$${(value / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        },
        moneyNoSymbol(value) {
            return (value / 100).toFixed(2);
        },
        sortByPrice(options) {
            return options.sort((a,b) => Number(a.price) - Number(b.price));
        },
        setDefaultQuantities() {
            this.quantities = this.product.options.map((item, index) => {
                return 0;
            })
        },
        increaseQuantity(index) {
            if (this.product.gift_card || this.quantities[index] < this.product.options[index].quantity) {
                this.quantities[index]++;
            }
        },
        decreaseQuantity(index) {
            if (this.quantities[index] > 0) {
                this.quantities[index]--;
            }
        },
        buildProductCall() {
            const products = [];

            // Add any selected products
            this.quantities.forEach((quantity, index) => {
                if (quantity > 0) {
                    products.push({
                        id: this.product.options[index].id,
                        quantity: Number(quantity),
                    });
                }
            });
            return products;
        },
        addToCart() {
            const products = this.buildProductCall();

            this.submitted = true;
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify({items: products})
            })
                .then((response) => {
                    if (response.ok) {
                        return response;
                    }
                    throw new Error(response.json());
                })
                .then(response => {
                    this.setDefaultQuantities();
                    this.submitted = false;
                    this.success = true;
                    this.show_cart_link = true;
                    $.ajax({
                        url: "/cart.js",
                        dataType: "json",
                        cache: false,
                        success: function success(cart) {
                            //block scrolling on mobile
                            if ($(window).width() <= 798) {
                                //$("body").addClass("blocked-scroll");
                            }
                            window.refreshCart(cart);
                            if ($("#header").is(":visible")) {
                                $("#header .cart_container").addClass("active_link");
                            } else if ($(".sticky_nav--stick").length) {
                                $(".sticky_nav .cart_container").addClass("active_link");
                            } else {
                                $(".top_bar .cart_container").addClass("active_link");
                            }
                        }
                    });
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        },

        /* Alert when a product is back in stock */
        backInStockAlert(e, variantId) {
            const variant = this.product.options.find(({id}) => id === variantId)
            if (variant) {
                window._swat.addToWatchList(e, {
                    empi: Number(this.product.product_id),
                    du: `https://www.aussiecandlesupplies.com.au${this.product.url}`,
                    epi: variant.id,
                    pr: this.moneyNoSymbol(variant.price),
                    iu: this.product.image.replace(/^https?:/, ''),
                    variants: [{
                        [variant.title]: variant.id
                    }]
                });
            } else {
                console.log('Variant not found');
            }
        },
    },
    template: `
<article>
    <h3 v-if="showTitle"><a :href="product.url" v-text="product.name"></a></h3>
    <div v-if="product.rating" v-html="product.rating" class="product-rating"></div>
    <div class="container">
        <div class="three column medium-down--one-third"><strong>Options</strong></div>
        <div class="align_right four column medium-down--two-thirds"><strong>Price</strong></div>
        <div class="align_right three column medium-down--hidden"></div>
        <div class="align_right six column medium-down--hidden"><strong v-if="!viewOnly">Qty</strong></div>
    </div>
    <div class="container option-row" v-for="(row, index) in sortByPrice(product.options)">
        <div class="three column medium-down--one-third"><strong v-text="row.title"></strong></div>
        <div class="align_right four column medium-down--two-thirds"><span class="price-no-discount" v-if="row.original_price && row.original_price !== row.price" v-text="money(row.original_price)"></span> <span class="current_price" v-text="money(row.price)"></span></div>
        <div class="align_left three column medium-down--hidden column--unit-price"><span v-if="hasUnitPrice">({{ money(row.unit_price) }}/{{ row.unit_price_label }})</span></div>
        <div class="align_right six column medium-down--one-whole">
            <strong v-if="!product.gift_card && row.quantity <= 0"><a @click.prevent="backInStockAlert($event, row.id)" :href="product.url + '#confirmNotify=' + row.title">Email Me When In Stock</a></strong>
            <div v-else-if="viewOnly"><strong><a :href="product.url">View Kit</a></strong></div>
              <div v-else class="product-quantity-box">
                <div class="quantity-fields-wrapper">
                    <span class="ss-icon product-minus" @click="decreaseQuantity(index)" data-func="minus"><span class="icon-minus"></span></span>
                    <input type="number" v-model="quantities[index]" min="0" size="2" step="1" :max="row.quantity" class="quantity" />
                    <span class="ss-icon product-plus" @click="increaseQuantity(index)" data-func="plus"><span class="icon-plus"></span></span>
                </div>
              </div>
        </div>
    </div>
    <div class="container mt">
        <div class="three-fifths column payment-options">
            <div class=" large-down--hidden">
            <p class="nowrap">{{ paypalMessage }} <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAxcHgiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAxMDEgMzIiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaW5ZTWluIG1lZXQiIHhtbG5zPSJodHRwOiYjeDJGOyYjeDJGO3d3dy53My5vcmcmI3gyRjsyMDAwJiN4MkY7c3ZnIj48cGF0aCBmaWxsPSIjMDAzMDg3IiBkPSJNIDEyLjIzNyAyLjggTCA0LjQzNyAyLjggQyAzLjkzNyAyLjggMy40MzcgMy4yIDMuMzM3IDMuNyBMIDAuMjM3IDIzLjcgQyAwLjEzNyAyNC4xIDAuNDM3IDI0LjQgMC44MzcgMjQuNCBMIDQuNTM3IDI0LjQgQyA1LjAzNyAyNC40IDUuNTM3IDI0IDUuNjM3IDIzLjUgTCA2LjQzNyAxOC4xIEMgNi41MzcgMTcuNiA2LjkzNyAxNy4yIDcuNTM3IDE3LjIgTCAxMC4wMzcgMTcuMiBDIDE1LjEzNyAxNy4yIDE4LjEzNyAxNC43IDE4LjkzNyA5LjggQyAxOS4yMzcgNy43IDE4LjkzNyA2IDE3LjkzNyA0LjggQyAxNi44MzcgMy41IDE0LjgzNyAyLjggMTIuMjM3IDIuOCBaIE0gMTMuMTM3IDEwLjEgQyAxMi43MzcgMTIuOSAxMC41MzcgMTIuOSA4LjUzNyAxMi45IEwgNy4zMzcgMTIuOSBMIDguMTM3IDcuNyBDIDguMTM3IDcuNCA4LjQzNyA3LjIgOC43MzcgNy4yIEwgOS4yMzcgNy4yIEMgMTAuNjM3IDcuMiAxMS45MzcgNy4yIDEyLjYzNyA4IEMgMTMuMTM3IDguNCAxMy4zMzcgOS4xIDEzLjEzNyAxMC4xIFoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDAzMDg3IiBkPSJNIDM1LjQzNyAxMCBMIDMxLjczNyAxMCBDIDMxLjQzNyAxMCAzMS4xMzcgMTAuMiAzMS4xMzcgMTAuNSBMIDMwLjkzNyAxMS41IEwgMzAuNjM3IDExLjEgQyAyOS44MzcgOS45IDI4LjAzNyA5LjUgMjYuMjM3IDkuNSBDIDIyLjEzNyA5LjUgMTguNjM3IDEyLjYgMTcuOTM3IDE3IEMgMTcuNTM3IDE5LjIgMTguMDM3IDIxLjMgMTkuMzM3IDIyLjcgQyAyMC40MzcgMjQgMjIuMTM3IDI0LjYgMjQuMDM3IDI0LjYgQyAyNy4zMzcgMjQuNiAyOS4yMzcgMjIuNSAyOS4yMzcgMjIuNSBMIDI5LjAzNyAyMy41IEMgMjguOTM3IDIzLjkgMjkuMjM3IDI0LjMgMjkuNjM3IDI0LjMgTCAzMy4wMzcgMjQuMyBDIDMzLjUzNyAyNC4zIDM0LjAzNyAyMy45IDM0LjEzNyAyMy40IEwgMzYuMTM3IDEwLjYgQyAzNi4yMzcgMTAuNCAzNS44MzcgMTAgMzUuNDM3IDEwIFogTSAzMC4zMzcgMTcuMiBDIDI5LjkzNyAxOS4zIDI4LjMzNyAyMC44IDI2LjEzNyAyMC44IEMgMjUuMDM3IDIwLjggMjQuMjM3IDIwLjUgMjMuNjM3IDE5LjggQyAyMy4wMzcgMTkuMSAyMi44MzcgMTguMiAyMy4wMzcgMTcuMiBDIDIzLjMzNyAxNS4xIDI1LjEzNyAxMy42IDI3LjIzNyAxMy42IEMgMjguMzM3IDEzLjYgMjkuMTM3IDE0IDI5LjczNyAxNC42IEMgMzAuMjM3IDE1LjMgMzAuNDM3IDE2LjIgMzAuMzM3IDE3LjIgWiI+PC9wYXRoPjxwYXRoIGZpbGw9IiMwMDMwODciIGQ9Ik0gNTUuMzM3IDEwIEwgNTEuNjM3IDEwIEMgNTEuMjM3IDEwIDUwLjkzNyAxMC4yIDUwLjczNyAxMC41IEwgNDUuNTM3IDE4LjEgTCA0My4zMzcgMTAuOCBDIDQzLjIzNyAxMC4zIDQyLjczNyAxMCA0Mi4zMzcgMTAgTCAzOC42MzcgMTAgQyAzOC4yMzcgMTAgMzcuODM3IDEwLjQgMzguMDM3IDEwLjkgTCA0Mi4xMzcgMjMgTCAzOC4yMzcgMjguNCBDIDM3LjkzNyAyOC44IDM4LjIzNyAyOS40IDM4LjczNyAyOS40IEwgNDIuNDM3IDI5LjQgQyA0Mi44MzcgMjkuNCA0My4xMzcgMjkuMiA0My4zMzcgMjguOSBMIDU1LjgzNyAxMC45IEMgNTYuMTM3IDEwLjYgNTUuODM3IDEwIDU1LjMzNyAxMCBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzAwOWNkZSIgZD0iTSA2Ny43MzcgMi44IEwgNTkuOTM3IDIuOCBDIDU5LjQzNyAyLjggNTguOTM3IDMuMiA1OC44MzcgMy43IEwgNTUuNzM3IDIzLjYgQyA1NS42MzcgMjQgNTUuOTM3IDI0LjMgNTYuMzM3IDI0LjMgTCA2MC4zMzcgMjQuMyBDIDYwLjczNyAyNC4zIDYxLjAzNyAyNCA2MS4wMzcgMjMuNyBMIDYxLjkzNyAxOCBDIDYyLjAzNyAxNy41IDYyLjQzNyAxNy4xIDYzLjAzNyAxNy4xIEwgNjUuNTM3IDE3LjEgQyA3MC42MzcgMTcuMSA3My42MzcgMTQuNiA3NC40MzcgOS43IEMgNzQuNzM3IDcuNiA3NC40MzcgNS45IDczLjQzNyA0LjcgQyA3Mi4yMzcgMy41IDcwLjMzNyAyLjggNjcuNzM3IDIuOCBaIE0gNjguNjM3IDEwLjEgQyA2OC4yMzcgMTIuOSA2Ni4wMzcgMTIuOSA2NC4wMzcgMTIuOSBMIDYyLjgzNyAxMi45IEwgNjMuNjM3IDcuNyBDIDYzLjYzNyA3LjQgNjMuOTM3IDcuMiA2NC4yMzcgNy4yIEwgNjQuNzM3IDcuMiBDIDY2LjEzNyA3LjIgNjcuNDM3IDcuMiA2OC4xMzcgOCBDIDY4LjYzNyA4LjQgNjguNzM3IDkuMSA2OC42MzcgMTAuMSBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzAwOWNkZSIgZD0iTSA5MC45MzcgMTAgTCA4Ny4yMzcgMTAgQyA4Ni45MzcgMTAgODYuNjM3IDEwLjIgODYuNjM3IDEwLjUgTCA4Ni40MzcgMTEuNSBMIDg2LjEzNyAxMS4xIEMgODUuMzM3IDkuOSA4My41MzcgOS41IDgxLjczNyA5LjUgQyA3Ny42MzcgOS41IDc0LjEzNyAxMi42IDczLjQzNyAxNyBDIDczLjAzNyAxOS4yIDczLjUzNyAyMS4zIDc0LjgzNyAyMi43IEMgNzUuOTM3IDI0IDc3LjYzNyAyNC42IDc5LjUzNyAyNC42IEMgODIuODM3IDI0LjYgODQuNzM3IDIyLjUgODQuNzM3IDIyLjUgTCA4NC41MzcgMjMuNSBDIDg0LjQzNyAyMy45IDg0LjczNyAyNC4zIDg1LjEzNyAyNC4zIEwgODguNTM3IDI0LjMgQyA4OS4wMzcgMjQuMyA4OS41MzcgMjMuOSA4OS42MzcgMjMuNCBMIDkxLjYzNyAxMC42IEMgOTEuNjM3IDEwLjQgOTEuMzM3IDEwIDkwLjkzNyAxMCBaIE0gODUuNzM3IDE3LjIgQyA4NS4zMzcgMTkuMyA4My43MzcgMjAuOCA4MS41MzcgMjAuOCBDIDgwLjQzNyAyMC44IDc5LjYzNyAyMC41IDc5LjAzNyAxOS44IEMgNzguNDM3IDE5LjEgNzguMjM3IDE4LjIgNzguNDM3IDE3LjIgQyA3OC43MzcgMTUuMSA4MC41MzcgMTMuNiA4Mi42MzcgMTMuNiBDIDgzLjczNyAxMy42IDg0LjUzNyAxNCA4NS4xMzcgMTQuNiBDIDg1LjczNyAxNS4zIDg1LjkzNyAxNi4yIDg1LjczNyAxNy4yIFoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDA5Y2RlIiBkPSJNIDk1LjMzNyAzLjMgTCA5Mi4xMzcgMjMuNiBDIDkyLjAzNyAyNCA5Mi4zMzcgMjQuMyA5Mi43MzcgMjQuMyBMIDk1LjkzNyAyNC4zIEMgOTYuNDM3IDI0LjMgOTYuOTM3IDIzLjkgOTcuMDM3IDIzLjQgTCAxMDAuMjM3IDMuNSBDIDEwMC4zMzcgMy4xIDEwMC4wMzcgMi44IDk5LjYzNyAyLjggTCA5Ni4wMzcgMi44IEMgOTUuNjM3IDIuOCA5NS40MzcgMyA5NS4zMzcgMy4zIFoiPjwvcGF0aD48L3N2Zz4" class="paypal-logo" role="presentation" alt="PayPal Credit" aria-hidden="true" /></p>
            <p class="nowrap" v-if="afterpayMessage && afterpayLogo">{{ afterpayMessage }} <img :src="afterpayLogo" class="afterpay-logo" alt="afterpay" /></p>
            </div>
        </div>
        <div class="two-fifths column align_right large-down--one-whole" v-if="hasStock && !viewOnly">
            <button class="global-button global-button--text" disabled v-if="success">Added to Cart!</button>
            <button class="global-button global-button--text" disabled v-else-if="!hasSelected">Select Quantity</button>
            <button class="global-button global-button--primary add-to-cart" v-else :disabled="submitted" @click.prevent="addToCart">{{ submitted ? 'Adding...' : 'Add to Cart' }}</button>
            <a href="/cart" class="mt global-button global-button--primary add-to-cart" v-if="show_cart_link">Go to cart</a>
        </div>
    </div>
</article>`
}